// Globals
import React from 'react';
import { useTranslation } from 'react-i18next';

// Components
import { PasswordInput } from '@/ui';
import { Form, FormItem } from '@/components';
import { StyledButton, StyledTitle } from '../Styled';

// Helpers
import { AuthFieldsNames, TResetPasswordFormValues } from '../../helpers/types';
import { useGetFormValidationRules } from '../../hooks';

interface IResetPasswordForm {
  handleSubmit: (values: TResetPasswordFormValues) => void;
  isLoading: boolean;
}

const ResetPasswordForm = ({ handleSubmit, isLoading }: IResetPasswordForm) => {
  const { t } = useTranslation(['auth', 'common']);

  const validationRules = useGetFormValidationRules();

  const placeholder = t('common_placeholder_input', { ns: 'common' });

  return (
    <>
      <StyledTitle>{t('auth_reset_password_title')}</StyledTitle>

      <Form onFinish={handleSubmit}>
        <FormItem
          name={AuthFieldsNames.NEW_PASSWORD}
          label={t('auth_reset_new_password')}
          rules={validationRules[AuthFieldsNames.NEW_PASSWORD]}
        >
          <PasswordInput placeholder={placeholder} />
        </FormItem>

        <FormItem
          name={AuthFieldsNames.CONFIRM_PASSWORD}
          label={t('auth_reset_repeat_password')}
          rules={[
            ...validationRules[AuthFieldsNames.NEW_PASSWORD],
            ({ getFieldValue }) => ({
              validator(_, value) {
                if (!value || getFieldValue(AuthFieldsNames.NEW_PASSWORD) === value) {
                  return Promise.resolve();
                }

                return Promise.reject(
                  t('validation_message_confirm_password', {
                    ns: 'common',
                  }),
                );
              },
            }),
          ]}
        >
          <PasswordInput placeholder={placeholder} />
        </FormItem>

        <StyledButton type="primary" htmlType="submit" loading={isLoading}>
          {t('auth_reset_password_save')}
        </StyledButton>
      </Form>
    </>
  );
};

export default ResetPasswordForm;
